import store from "../app/ReduxStore";
import reducers from "../app/Reducers";

/**
 * a field on an object in the store has changed
 * @param objectPath dot notation path to the object in the store
 * @param field the field on the object
 * @param value the new value
 */
export const dispatchFieldChanged = (objectPath, field, value) => {
	store.dispatch({type: reducers.ACTION_TYPES.UPDATE_DATA, payload: {path: objectPath, field: field, value: value}});
};
export const dispatchField = (path, value) => {
	const parts = path.split('.');
	const partsPath = parts.length > 1 ? parts.slice(0, parts.length - 1).join('.') : undefined;
	dispatchFieldChanged(partsPath || undefined, parts[parts.length - 1], value);
};
